/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import SwatchGroup from '@salesforce/retail-react-app/app/theme/components/project/swatch-group'

export default {
    ...SwatchGroup,
    variants: {
        circle: (props) => {
            const originalCircle = SwatchGroup.variants.circle(props)
            const pdpSize = '25px'
            const pdpInner = props.selected ? '19px' : '25px'
            return {
                ...originalCircle,
                swatch: {
                    ...originalCircle.swatch,
                    width: props.ispdp ? pdpSize : '20px',
                    minWidth: props.selected
                        ? props.ispdp
                            ? pdpSize
                            : '10px'
                        : props.ispdp
                        ? pdpSize
                        : '20px',
                    height: props.ispdp ? pdpSize : '20px',
                    padding: props.ispdp
                        ? props.selected
                            ? '2px'
                            : '0px'
                        : originalCircle.swatch.padding,
                    border: props.selected ? '1px solid' : 'none',
                    borderColor: props.selected ? 'black.100' : 'transparent',
                    boxShadow: 'none',
                    _before: {
                        ...originalCircle.swatch._before,
                        height: props.selected
                            ? props.ispdp
                                ? pdpSize
                                : 5
                            : props.ispdp
                            ? pdpSize
                            : 3,
                        zIndex: 0,
                        left: props?.selected
                            ? props.ispdp
                                ? '12px'
                                : '8.5px'
                            : props.ispdp
                            ? '12px'
                            : '10px',
                        top: props?.selected
                            ? props.ispdp
                                ? '0px'
                                : '-1px'
                            : props.ispdp
                            ? '0px'
                            : '5px',
                        backgroundColor: 'gray.750'
                    },
                    _hover: {},
                    marginRight: props.ispdp ? '25px' : 0,
                    marginBottom: props.ispdp ? 0 : 0,
                    marginTop: props.ispdp ? '20px' : 0,
                    backgroundColor: 'transparent'
                },
                swatchButton: {
                    ...originalCircle.swatchButton,
                    width: props.selected
                        ? props.ispdp
                            ? pdpInner
                            : '10px'
                        : props.ispdp
                        ? pdpInner
                        : '14px',
                    minWidth: props.selected
                        ? props.ispdp
                            ? pdpInner
                            : '10px'
                        : props.ispdp
                        ? pdpInner
                        : '14px',
                    height: props.selected
                        ? props.ispdp
                            ? pdpInner
                            : '10px'
                        : props.ispdp
                        ? pdpInner
                        : '14px'
                }
            }
        },
        square: (props) => {
            const originalSquare = SwatchGroup.variants.square(props)
            return {
                ...originalSquare,
                swatch: {
                    ...originalSquare.swatch,
                    marginRight: props.ispdp ? '15px' : '10px',
                    marginBottom: props.ispdp ? 0 : 0,
                    marginTop: props.ispdp ? '20px' : '10px',
                    fontWeight: props.ispdp ? '300' : '400',
                    letterSpacing: props.ispdp ? '1px' : 'unset',
                    borderColor: props.disabled ? 'gray.500' : 'transparent',
                    width: 'fit-content',
                    minWidth: props.ispdp ? '45px' : '39px',
                    height: props.ispdp ? '45px' : '39px',
                    backgroundColor:
                        props.disabled && props.selected
                            ? 'black.100'
                            : props.disabled
                            ? 'gray.40'
                            : props.selected
                            ? 'black.100'
                            : 'gray.400',
                    color: props.disabled ? 'gray.600' : props.selected ? 'white' : 'black.100',
                    ...(props.ispdp
                        ? {}
                        : {
                              overflow: 'hidden'
                          }),
                    _active: {
                        background: 'black.100',
                        color: 'white',
                        border: 'none',
                        _hover: {
                            backgroundColor: 'black.100 !important',
                            color: 'white !important',
                            border: 'none'
                        }
                    },
                    backgroundImage: 'none',
                    // Commented until clarified if OOS should be clickable or no YR-272 AC#5
                    // pointerEvents: props.disabled ? 'none' : 'auto',
                    _before: {
                        content: '""',
                        display: `${props.disabled ? 'block' : 'none'}`,
                        position: 'absolute',
                        height: props.ispdp ? '60px' : '56px',
                        width: '1px',
                        transform: props.ispdp ? 'rotate(45deg)' : 'rotate(45deg)',
                        backgroundColor: 'gray.600',
                        zIndex: 1,
                        ...(props.ispdp
                            ? {}
                            : {
                                  left: '50%',
                                  top: '-25%'
                              })
                    }
                }
            }
        },
        charm: (props) => ({
            swatch: {
                alignItems: 'stretch',
                backgroundColor: 'transparent',
                borderColor: props.selected && !props.disabled ? 'black.100' : 'transparent',
                borderRadius: 0,
                borderStyle: 'solid',
                borderWidth: '2px',
                color: 'black.100',
                cursor: 'pointer',
                height: 'auto',
                justifyContent: 'flex-start',
                marginBottom: '16px',
                marginRight: '12px',
                marginTop: '10px',
                minHeight: '112px',
                minWidth: '70px',
                opacity: 1,
                padding: '0',
                transition: 'none',
                width: '70px',
                _active: {
                    backgroundColor: 'transparent'
                },
                _focusVisible: {
                    boxShadow: 'outline'
                },
                _hover: {
                    backgroundColor: 'transparent',
                    borderColor: props.selected && !props.disabled ? 'black.100' : 'transparent',
                    boxShadow: 'none',
                    transform: 'none'
                }
            },
            swatchButton: {
                alignItems: 'center',
                flexDirection: 'column',
                height: 'auto',
                justifyContent: 'flex-start',
                minWidth: 0,
                width: '100%'
            }
        })
    }
}
